// One canonical reader for "what email do we show / send for this user?"
//
// Why this exists: pre-claim users have only the invited email stored in a
// type-specific column; post-claim users have the real auth login email
// mirrored into the type-specific app table. Every UI / notification surface
// that shows or templates a user's email must use this helper so the
// pre/post-claim distinction is decided in one place.
//
// Per-type column map:
//   client / advisor: temp_email pre-claim; users.email (joined as row.user) post-claim
//   teamMember:       team_member_profiles.email serves both phases
//   master:           users.email (no invite phase)

export function getDisplayEmail(row, type) {
  if (!row) return { email: null, claimed: false, source: null };

  if (type === 'client' || type === 'advisor') {
    const claimed = !!row.invite_claimed;
    if (claimed && row.user?.email) {
      return { email: row.user.email, claimed: true, source: 'auth' };
    }
    if (row.temp_email) {
      return { email: row.temp_email, claimed: false, source: 'temp' };
    }
    return { email: null, claimed, source: null };
  }

  if (type === 'teamMember') {
    const claimed = !!row.user_id;
    return {
      email: row.email || null,
      claimed,
      source: claimed ? 'auth' : 'temp',
    };
  }

  if (type === 'master') {
    return { email: row.email || null, claimed: true, source: 'auth' };
  }

  return { email: null, claimed: false, source: null };
}

export function getClaimStatus(row, type) {
  return getDisplayEmail(row, type).claimed ? 'active' : 'invited';
}
